import { Injectable, Output, EventEmitter } from '@angular/core';
import { UtilsService } from '../services/utils.service';
import { LanguagePipe } from './language.pipe';
import { BusinesLogicService } from './business-logic.service';
import { ModalHelper } from '../components/modal/modal.helper';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { DeskConfig } from "../models/deskconfig.model";

declare var $;

@Injectable()
export class DataService {
  @Output() turnUpdate = new EventEmitter();
  @Output() selectedTurnUpdate = new EventEmitter();

  /* Session store all grants and data session data */
  public session: object;
  public _token: string = null;
  private _turn: object = null;
  private _selectedTurn: object = null;
  public desks: any = [];
  public saveQueue: string = null;
  public offices: Array<object> = [];
  public onlineDesks: Array<object> = [];
  public redError: boolean = false;
  public timeExceed: boolean = false;
  private _deskInUse: boolean = false;

  public deskInUseDeskName: string = "";
  public deskInUseHostAddr: string = "";
  public deskInUseOffice: string = "";
  public deskInUseHour: string = "";
  public deskInUseDate: string = "";
  public inQueue: number = 0;
  public enableRecallSupervisor = false;

  public json_config: DeskConfig | null = null;

  public deskStopped: boolean = false;
  public pauseModalTurn: boolean = false;

  public lastCalls: Array<object> = [];
  public turnStatusInViewer: Array<object> = [];
  /* Actions container for update list in plan mode or supervisor mode */
  private _actionContainer: number = 0;

  public dniTranslation = "DNI del cliente";
  public ccodeTranslation = "Código del cliente";

  public configuration: object = {
    "language": "ES",
    "getTurnToInit": false,
    "redirectFirstAndLastMode": false,
    "recoverFinishTurn": false,
    "checkQueue": true,
    "secsCheckQueue": 6000,
    "activeSupervisor": false,
    "cancelTurnButton": true,
    "recoverFinishedTurn": false,
    "questSupervisorDesk": true,
    "deleteSupervisorDesk": true,
    "showCcodeInput": false,
    "showCcodeInputMode": 1, /* 1 es código especial, 2 código personal (DNI...) */
    "fontSize": "20px",
    "actionToCall": 1,
    "noShow": "#343a40",
    "inWait": "#28a745",
    "redirect": "#dc3545",
    "finished": "#007bff",
    "cancelled": "#dc3545",
    "return": "#ffc107",
    "inAttention": "#17a2b8",
    "chatEnabled": false,
    "alertEnabled": false,
    "secsCheckChat": 10000,
    "autoResponse": this._lang.transform("received"),
    "alertMessage": this._lang.transform("alertDefaultMessage"),
    "phoneEnabled": false,
    "phoneKindId": null,
    "showQueueInfo": true,
    "showKindInfo": true,
    "finishTurnButton": false,
    "autoCheckQueues": false,
    "autoCheckQueuesTime": 5,
    "showPostponeButton": false,
    "queuedesk": false,
    "useOnlyDeskRedirection": false,
    "showViewerInfo": false,
    "showAllCallsViewer": false
  };

  /* Store the actual turn data */
  get turn(): object {
    return this._turn;
  }
  set turn(value: object) {
    this._turn = value;
    this.turnChanged();
  }

  set token(value: string) {
    sessionStorage.setItem(this._token, value);
  }

  get token(): string {
    return sessionStorage.getItem(this._token) || '';
  }

  get deskInUse(): boolean {
    return this._deskInUse;
  }
  set deskInUse(value: boolean) {
    this._deskInUse = value;
    this._modal.show("deskDisconnectedModal");
    let self = this;
    $('#deskDisconnectedModal').on('hidden.bs.modal', function (e) {
      self.deleteStoredCredentials();
      localStorage.removeItem("office");
      localStorage.removeItem("desk");
      window.location.reload();
    });
  }

  set actionContainer(number: number) {
    this.turnChanged();
  }

  /* Store the selected turn data */
  get selectedTurn(): object {
    return this._selectedTurn;
  }
  set selectedTurn(value: object) {
    this._selectedTurn = value;
    this.selectedTurnChanged();
  }
  /* Name of localStorage session data */
  sessionName: string = "session";

  constructor(private _utils: UtilsService,
              private _modal: ModalHelper,
              private _lang: LanguagePipe) { }

  /* Store login credentials on LocalStorage */
  public storeCredentials(credentials: any): void {
    credentials = this._utils.toString(credentials);
    this._utils.localStorage("post", this.sessionName, credentials);
  }

  /* Get the store credentials */
  public getStoredCredentials(): any {
    let credentials = this._utils.localStorage("get", this.sessionName);
    return this._utils.toJson(credentials);
  }

  /* Delete the store credentials */
  public deleteStoredCredentials(): void {
    this._utils.localStorage("delete", this.sessionName);
  }

  /* Check if user is logged */
  public isLogged(): boolean {
    let session: string = this._utils.localStorage("get", this.sessionName);
    if (session === null || typeof session === "undefined") {
      return false;
    }
    return true;
  }

  /* Check if a turn is active */
  public turnIsActive(): boolean {
    if (this.turn == null) {
      return false;
    }
    return true;
  }

  /* When the turn data change */
  public turnChanged(): void {
    this.turnUpdate.emit(this._turn);
  }

  /* When the selected turn data change */
  public selectedTurnChanged(): void {
    this.selectedTurnUpdate.emit(this._selectedTurn);
  }

  /* Close actual turn */
  public closeTurn(): void {
    this.turn = null;
  }

}
